// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IOcrAccountOrderServiceDto } from './IOcrAccountOrderServiceDto';
import {
    IOcrAccountOrderServiceDtoFromJSON,
    IOcrAccountOrderServiceDtoFromJSONTyped,
    IOcrAccountOrderServiceDtoToJSON,
    IOcrAccountOrderServiceDtoToJSONTyped,
} from './IOcrAccountOrderServiceDto';

/**
 * 
 * @export
 * @interface IOcrAccountOrderDto
 */
export interface IOcrAccountOrderDto {
    /**
     * 
     * @type {number}
     * @memberof IOcrAccountOrderDto
     */
    account_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IOcrAccountOrderDto
     */
    account_type?: IOcrAccountOrderDtoAccountTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IOcrAccountOrderDto
     */
    order?: number;
    /**
     * 
     * @type {string}
     * @memberof IOcrAccountOrderDto
     */
    plan_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IOcrAccountOrderDto
     */
    available_balance?: number;
    /**
     * 
     * @type {string}
     * @memberof IOcrAccountOrderDto
     */
    proof_of_expenses_type?: string;
    /**
     * 
     * @type {Date}
     * @memberof IOcrAccountOrderDto
     */
    coverage_date_start?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IOcrAccountOrderDto
     */
    coverage_date_end?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IOcrAccountOrderDto
     */
    submit_claims_date_end?: Date;
    /**
     * 
     * @type {Array<IOcrAccountOrderServiceDto>}
     * @memberof IOcrAccountOrderDto
     */
    services?: Array<IOcrAccountOrderServiceDto>;
}

/**
* @export
* @enum {string}
*/
export enum IOcrAccountOrderDtoAccountTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}


/**
 * Check if a given object implements the IOcrAccountOrderDto interface.
 */
export function instanceOfIOcrAccountOrderDto(value: object): value is IOcrAccountOrderDto {
    return true;
}

export function IOcrAccountOrderDtoFromJSON(json: any): IOcrAccountOrderDto {
    return IOcrAccountOrderDtoFromJSONTyped(json, false);
}

export function IOcrAccountOrderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrAccountOrderDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'order': json['order'] == null ? undefined : json['order'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'available_balance': json['available_balance'] == null ? undefined : json['available_balance'],
        'proof_of_expenses_type': json['proof_of_expenses_type'] == null ? undefined : json['proof_of_expenses_type'],
        'coverage_date_start': json['coverage_date_start'] == null ? undefined : (new Date(json['coverage_date_start'])),
        'coverage_date_end': json['coverage_date_end'] == null ? undefined : (new Date(json['coverage_date_end'])),
        'submit_claims_date_end': json['submit_claims_date_end'] == null ? undefined : (new Date(json['submit_claims_date_end'])),
        'services': json['services'] == null ? undefined : ((json['services'] as Array<any>).map(IOcrAccountOrderServiceDtoFromJSON)),
    };
}

export function IOcrAccountOrderDtoToJSON(json: any): IOcrAccountOrderDto {
    return IOcrAccountOrderDtoToJSONTyped(json, false);
}

export function IOcrAccountOrderDtoToJSONTyped(value?: IOcrAccountOrderDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_id': value['account_id'],
        'account_type': value['account_type'],
        'order': value['order'],
        'plan_name': value['plan_name'],
        'available_balance': value['available_balance'],
        'proof_of_expenses_type': value['proof_of_expenses_type'],
        'coverage_date_start': value['coverage_date_start'] == null ? undefined : ((value['coverage_date_start']).toISOString().substring(0,10)),
        'coverage_date_end': value['coverage_date_end'] == null ? undefined : ((value['coverage_date_end']).toISOString().substring(0,10)),
        'submit_claims_date_end': value['submit_claims_date_end'] == null ? undefined : ((value['submit_claims_date_end']).toISOString().substring(0,10)),
        'services': value['services'] == null ? undefined : ((value['services'] as Array<any>).map(IOcrAccountOrderServiceDtoToJSON)),
    };
}

